import { UploadProgress } from "./UploadProgress";

export default UploadProgress;